import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { getProductName } from "../i18n";
import { ProductImg } from "./ProductImg";

export const ProductCard = ({ product, priority = false }) => {
  const { t, lang } = useLanguage();

  return (
    <Link
      to={`/product/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group block"
    >
      <div className="relative aspect-[3/4] product-image-wrap border border-white/5 group-hover:border-yellow-400/40 transition-colors duration-500">
        <ProductImg
          src={product.images?.[0]}
          alt={getProductName(product, lang)}
          loading={priority ? "eager" : "lazy"}
          className="w-full h-full object-cover image-cinematic"
        />
        {product.badge && (
          <span className="absolute top-3 left-3 bg-yellow-400 text-black text-[10px] font-black tracking-[0.2em] uppercase px-2.5 py-1">
            {product.badge === "THE ORIGINAL" ? t.hero.originalBadge : product.badge}
          </span>
        )}
        <span className="absolute top-3 right-3 bg-black/70 backdrop-blur-sm border border-yellow-400/40 text-yellow-400 text-[9px] font-bold tracking-[0.25em] uppercase px-2 py-1">
          {t.comingSoon.badge}
        </span>

        <div className="absolute bottom-3 left-3 right-3 bg-black/85 backdrop-blur-sm text-white border border-white/20 py-3 text-[11px] uppercase font-bold tracking-[0.25em] opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-400 text-center">
          {t.showcase.viewProduct}
        </div>
      </div>

      <div className="mt-4 flex items-start justify-between gap-2">
        <div>
          <h3 className="text-sm font-bold uppercase tracking-wide leading-tight">
            {getProductName(product, lang)}
          </h3>
          <p className="text-[11px] text-white/50 uppercase tracking-[0.25em] mt-1">
            {product.category.replace("-", " ")}
          </p>
        </div>
        <p className="text-sm font-bold whitespace-nowrap">
          ${product.price.toFixed(0)} USD
        </p>
      </div>
    </Link>
  );
};
